import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://35184af5cf75cece1c042d211c0d2ca0@o4511195280572416.ingest.de.sentry.io/4511195282407504",
  release: import.meta.env.VITE_SENTRY_RELEASE,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || (import.meta.env.PROD ? "production" : "development"),
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  enabled: import.meta.env.PROD,
});
